import Vue from 'vue'
import Vuex from 'vuex'
import getters from './getters'
import User from './modules/User'
import User_desktop from './modules/User_desktop'
import Area from './modules/Area'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    User,
    User_desktop,
    Area
  },
  getters
})